import React from "react";
import { Steps, Button, message } from "antd";
import { Row, Col } from "react-bootstrap";
import { SolutionOutlined, FormOutlined } from "@ant-design/icons";
import Dropdown from "../UI/Dropdown/Dropdown";
import Spinner from "../UI/Spinner/Spinner";

import DynamicFormBuilder from "../DynamicFormBuilder/DynamicFormBuilder";

const UnosZahtjevaReferentView = (props) => {
  const steps = [
    {
      title: "Odabir zahtjeva",
      content: "Second-content",
      icon: <SolutionOutlined />,
    },
    {
      title: "Unos zahtjeva",
      content: "Last-content",
      icon: <FormOutlined />,
    },
  ];

  const {
    current,
    selectedForm,
    dropdownFormHandler,
    otherProps,
    formData,
    next,
    prev,
    submitFormHandler,
    requestsLoaded,
    isLoading,
  } = props;

  const { Step } = Steps;

  const formOptions = formData.map((element) => (
    <option key={element.formId} value={element.formId}>
      {element.formDescription}
    </option>
  ));

  return (
    <div>
      <Row className="row justify-content-center">
        <Col xl={8} lg={10} md={12} className="align-self-center">
          <Steps current={current}>
            {steps.map((item) => (
              <Step icon={item.icon} key={item.title} title={item.title} />
            ))}
          </Steps>
          {current == 0 && (
            <Row>
              <Col className="steps-content step1">
                <Row className="row justify-content-center">
                  <Col lg={8} className="align-self-center">
                    <Dropdown
                      hidden
                      onChange={dropdownFormHandler}
                      value={selectedForm}
                      id={1}
                      center
                      label={"Odaberite zahtjev"}
                      asProperty="select"
                      map={formOptions}
                      text="Vrsta zahtjeva"
                      className="drop"
                      name="odabirZahtjeva"
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
          {current == 1 && (
            <Row>
              <Col className="steps-content step2">
                {requestsLoaded ? (
                  <DynamicFormBuilder {...otherProps} />
                ) : (
                  <>
                    <Spinner />
                  </>
                )}
              </Col>
            </Row>
          )}
          <div className="steps-action invert">
            {current < steps.length - 1 && (
              <Button
                type="primary"
                disabled={current == 0 && !selectedForm}
                onClick={next}
                role="button"
              >
                Nastavi
              </Button>
            )}
            {current === steps.length - 1 && (
              <Button
                loading={isLoading}
                type="primary"
                onClick={submitFormHandler}
                role="button"
              >
                Spremi zahtjev
              </Button>
            )}
            {current > 0 && (
              <Button
                style={{ margin: 8 }}
                onClick={() => prev()}
                className="ant-btn-back"
              >
                Povratak
              </Button>
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default UnosZahtjevaReferentView;
